import axios from 'axios'
import { Message } from 'element-ui'

// 业务层若已自行提示（Vant $toast），调用本函数可跳过全局红色 Message，避免两条重复提示
let _suppressGlobalErrorUntil = 0;
export function suppressGlobalError(){
    _suppressGlobalErrorUntil = Date.now() + 2000;
}


// 创建axios实例
const service = axios.create({
   // baseURL: process.env.BASE_API, // api的base_url
    baseURL:config.serverIP,
    timeout: 10000000000000000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    config.headers['token']      = localStorage.getItem("access_token")
    /* 【P415】`enterprise` 头只在有真实值时才发送。
       原实现无条件写 localStorage.getItem("enterprise")：未登录 / 无企业上下文时取到 null，
       axios 会把它序列化成**字面量字符串 "null"** 送上游；后端 admin / 通用域据此查企业，
       查不到即返回 450「账号登录失效」⇒ 前端按失效处理：清 token、弹登录层、crmWs.close()。
       更致命的是下方 450 分支会 removeItem("enterprise")，于是「一次 450」被永久放大成
       「之后每个请求都 450」——销售端 #/client 调 admin/getStaff、getRoomDate 时命中，
       表现为：登录层反复弹出 + WebSocket 被主动关闭且不再重连 ⇒ 消息气泡永远不更新。
       服务端在「不带该头」时按 token 自身企业上下文处理（实测 200），故缺省不发送是安全口径。 */
    var _ent = localStorage.getItem("enterprise")
    if (_ent && _ent !== 'null' && _ent !== 'undefined') {
        config.headers['enterprise'] = _ent
    }
    return config
}, error => {
    console.log(error) 
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 登录失效统一处理：后端 client 的 TokenCheck 返回 451(空token)/452(token无效)/456(账号禁用)，
        // admin 侧为 450；全部视为「需重新登录」。覆盖「记住登录」的两种存储 + client 内嵌登录层。
        if(res.code == 450 || res.code == 451 || res.code == 452 || res.code == 456){
            // 清理登录态（localStorage + sessionStorage，覆盖「记住登录」两种存储）
            localStorage.removeItem("access_token");
            localStorage.removeItem("enterprise");
            sessionStorage.removeItem("access_token");
            sessionStorage.removeItem("enterprise");
            // ★★【P301 修】原实现是 `return;` —— 即 **resolve(undefined)**。
            //   后果：业务层的 .then(res => …) 拿到 res=undefined，
            //   只能报「无响应（res 为空）」，**完全看不出是登录失效**；
            //   而且此时 token 已被清掉，后续所有请求的 token 头都是空 ⇒ 整页数据全空，
            //   表现成「列表空 / 批量条不出现 / Tab 切了没数据」，极难定位。
            // ⇒ 改为 **reject 一个带 code 的错误**，业务层可据 code 精确提示。
            var _authErr = new Error('登录已失效，请重新登录');
            _authErr.code = res.code;
            _authErr.authExpired = true;
            // client 页：token 失效时原地弹出内嵌登录层，延续「登录不跳转」体验（不再硬跳 /login）
            if (window.location.hash.indexOf("#/client") !== -1) {
                window.dispatchEvent(new CustomEvent("auth:expired"));
                return Promise.reject(_authErr);
            }
            /* 【P118】token 失效也回「本端自己的登录页」：
               销售 → #/client，市场 → #/market，财务 → 各自端。
               【P420】运营 → #/operation/login（独立登录页；原值 #/operation 是业务首页，
               落到那里只会白屏 + 连续 451，看起来像「退出后页面坏了」）。
               这里就地判定（不 import clientAuth，避免 util 之间循环依赖）。 */
            var __h = window.location.hash || '';
            var __home = (__h.indexOf('#/market') === 0) ? '#/market'
                       : (__h.indexOf('#/finance') === 0) ? '#/finance'
                       : (__h.indexOf('#/operation') === 0) ? '#/operation/login'
                       : '#/client';
            window.location.href = './' + __home;
            return Promise.reject(_authErr);
        }
        // 统一把后端 payload 返回给调用方，由业务层决定如何提示（避免此处吞掉 res 导致上层拿不到 msg）
        if (res.code == 200) {
            return response.data
        } else {
            // 延后到下一个宏任务：若业务层已自行提示（在其 then 中调用 suppressGlobalError），
            // 则不再弹全局红色提示，避免「两条提示重复」；无人处理时仍作为兜底提示保留。
            const _errMsg = response.data && response.data.msg ? response.data.msg : '操作失败';
            setTimeout(function(){
                if (Date.now() < _suppressGlobalErrorUntil) { return; }
                try {
                    Message && Message({
                        message: _errMsg,
                        type: 'error',
                        duration: 3 * 1000,
                    })
                } catch (e) { console.log('Message toast error', e); }
            }, 0);
            return response.data
        }
    },
    error => {
        try {
            Message && Message({
                message: ""+error,
                type: 'error',
                duration: 3 * 1000,
            })
        } catch (e) { console.log('Message toast error', e); }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/util/request.js